import React from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import '../styles/navbar.css';

import { connect } from 'react-redux';
import { logOut } from '../actions/authedUser'

class UnwrappedNavbar extends React.Component {
  logout = (e) => {
    e.preventDefault();
    
    this.props.logoutAction();
  }

  render() {
    return (
      <div className="navbar">
        <div className="top">
          <Link to={'/home'}>
            <button>HOME</button>
          </Link>
          <Link to={'/profile'}>
            <button>PROFILE</button>
          </Link>
          <Link to={'/campaign'}>
            <button>CAMPAIGN</button>
          </Link>
          <Link to={'/lobby'}>
            <button>LOBBY</button>
          </Link>
          {/* <Link to={'/dojo'}>
            <button>DOJO</button>
          </Link> */}
          <Link to={'/learn'}>
            <button>LEARN</button>
          </Link>
          {/* <Link to={'/editor'}>
            <button>EDITOR</button>
          </Link> */}
          <Link to={'/forum'}>
            <button>FORUM</button>
          </Link>
        </div>
        <div className="bottom">
          <button onClick={this.logout}>LOG OUT</button>
          {this.props.authedUser.id === '' &&
            <Redirect to={'/'} />
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps ({ authedUser }) {
  return {
    authedUser
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logoutAction: () => {
      dispatch(logOut()) 
    }
  }
}

export const Navbar = connect(mapStateToProps, mapDispatchToProps)(UnwrappedNavbar);